import { Action } from '@ngrx/store';

import { type } from './utils/util';
import { Fleet } from "../models/Fleet";
import { CustomAction } from "./utils/action";

const initialState = []

const ActionTypes = {
    FLEET_CREATE: type("FLEET_CREATE"),
}

export class FleetCreate implements Action {
    type = ActionTypes.FLEET_CREATE
    payload: {
      fleet: Fleet
    }

    constructor(args: {fleet: Fleet}) {
        this.payload = args
    }
}

export function FleetReducer(state = initialState, action: CustomAction) {
    switch(action.type) {
        case ActionTypes.FLEET_CREATE:
            return [...state, action.payload];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/states/fleet.reducer.ts